import NotFound from '@/views/errors/NotFound';
import Footer from '@/components/structure/Footer';
import TopNavigation from '@/components/structure/navigation/TopNavigation';

export default [
    {
        path: '/login/refresh',
        name: 'login-refresh',
        components: {
            footer: Footer,
            default: NotFound,
            topNavigation: TopNavigation,
        },
    },
    {
        path: '/404',
        name: '404',
        components: {
            footer: Footer,
            default: NotFound,
            topNavigation: TopNavigation,
        },
    },
    {
        path: '/*',
        redirect: '/404',
    },
];
